module.exports = __webpack_public_path__ + "satsuma-logo-black.svg?41d2bde751ca703c26d07bbf54cfac06";


//////////////////
// WEBPACK FOOTER
// ./static/satsuma-logo-black.svg
// module id = 572
// module chunks = 0